export enum ClientStateEnums {
  activo = 1,
  suspendido = 2,
  inactivo = 3
}